// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e3e60e92","977":"512f1423"}[chunkId] + ".chunk.js";
};